/**
 * @description 登入類型 (enum)
 */
export enum LoginTypesEnum {
  /** 前台會員登入 */
  FrontendLogin = '1',
  /** 前台會員登出 */
  FrontendLogout = '2',
  /** 後台會員登入 */
  BackendLogin = '3',
  /** 後台會員登出 */
  BackendLogout = '4'
}
